import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { APIResponseWrapper } from '../models/api-response-wrapper.model';

@Injectable({
  providedIn: 'root'
})
export class FcmTokenService { // Note: Angular service names should be singular.

  private baseUrl = `${environment.restApiUrl}users`; // Assuming your backend API base URL

  constructor(private http: HttpClient) { }

  updateFcmToken(userId: string, fcmToken: string): Observable<APIResponseWrapper<string>> {
    const params = new HttpParams()
      .set('userId', userId)
      .set('fcmToken', fcmToken);

    // The FcmTokenController returns a String, so we expect a string here.
    return this.http.put<APIResponseWrapper<string>>(`${this.baseUrl}/fcm-token`, null, { params });  
  }

  getFcmToken(userId: string): Observable<APIResponseWrapper<string>> {
    const params = new HttpParams().set('userId', userId);
    return this.http.get<APIResponseWrapper<string>>(`${this.baseUrl}/fcm-token`, { params });
  }

}